import React, { useState, useEffect } from 'react';
import { Button } from 'core/controls/button/Button';
import { Translate, TranslateHTML, withTranslate } from 'core/translate';
import Modal, {
  ModalBody,
  ModalCustomContent,
  ModalHeader,
} from '../../../components/modal/Modal';
import useLargeBreakpoint from '../../../hooks/useLargeBreakpoint';
import { getDeepUrl, getBaseUrl, getOrigin } from '../../../common/urlBuilder';
import fetchTinyUrl from '../../../api/fetchTinyUrl';
import CGISpinner from '../../../common/images/cgiSpinner/CGISpinner';

const SendLinkModal = ({
  onClose,
  translate,
  config,
  postalCode,
  modelInfo,
}) => {
  const { year, title, v3ServicesPath } = modelInfo;

  const ANALYTICS_KEY = 'send link';

  const isAtLeastLarge = useLargeBreakpoint();

  const [isCopied, setIsCopied] = useState(false);
  const [url, setUrl] = useState('');

  const header = translate('send.link.modal.header.v3');
  const brand = translate('mail.link.brand.v3');

  const copyRef = React.createRef();

  const onCopyLink = () => {
    const input = copyRef.current;
    let success;

    try {
      window.getSelection().selectAllChildren(input);
      success = document.execCommand('copy');
    } catch (e) {
      success = false;
    }

    setIsCopied(success);
  };

  useEffect(() => {
    const configUrl = getDeepUrl(getBaseUrl(), config, postalCode);
    const baseUrl = getOrigin();

    fetchTinyUrl(v3ServicesPath, configUrl, baseUrl).then((tinyUrl) => {
      setUrl(tinyUrl);
    });
  }, []);

  const Buttons = ({ onMailLinkClick }) => {
    return (
      <div className="send-link__buttons">
        <Button
          className="send-link__copy-link-button stat-button-link"
          onClick={onCopyLink}
          data-dtm={ANALYTICS_KEY}>
          <Translate value="copy.link.v3" />
        </Button>
        <Button
          as={'a'}
          href={`mailto:?subject=${translate('mail.link.subject.v3', {
            brand,
            carline: title,
          })}&body=${translate('mail.link.body.v3', {
            year,
            brand,
            carline: title,
            url,
          })}`}
          onClick={onMailLinkClick}
          className="send-link__mail-link-button stat-button-link"
          data-dtm={ANALYTICS_KEY}>
          <Translate value="mail.link.v3" />
        </Button>
      </div>
    );
  };

  return (
    <Modal
      fullscreen={false}
      isOpen={true}
      contentLabel={header}
      onRequestClose={onClose}
      className="send-link-modal"
      overlayClassName="send-link__modal-overlay">
      <ModalHeader
        text={header}
        analyticsKey={ANALYTICS_KEY}
        onClose={onClose}
      />
      {url ? (
        <ModalCustomContent>
          {({ setIsClosing, onCloseModal }) => (
            <ModalBody
              className="send-link__modal-body"
              innerClassName={'send-link__modal-body-inner'}>
              <>
                <div className="send-link__headline-container">
                  <TranslateHTML
                    className="send-link__headline"
                    value="send.link.header.v3"
                  />
                  {isCopied && (
                    <TranslateHTML
                      as="div"
                      className="send-link__notification"
                      value="send.link.copied.clipboard.v3"
                    />
                  )}
                </div>
                <div className="send-link__options">
                  <div
                    ref={copyRef}
                    className="send-link__input"
                    contentEditable
                    suppressContentEditableWarning>
                    {url}
                  </div>
                  {isAtLeastLarge && (
                    <Buttons
                      className="send-link__buttons"
                      onMailLinkClick={() =>
                        setIsClosing(true, onCloseModal(onClose))
                      }></Buttons>
                  )}
                </div>
                <TranslateHTML
                  as="div"
                  className="send-link__instruction"
                  value="send.link.instructions.v3"
                />

                {!isAtLeastLarge && (
                  <Buttons
                    className="send-link__buttons"
                    onMailLinkClick={() =>
                      setIsClosing(true, onCloseModal(onClose))
                    }></Buttons>
                )}
              </>
            </ModalBody>
          )}
        </ModalCustomContent>
      ) : (
        <div className="send-link__loading_container">
          <CGISpinner width={40} height={40} />
        </div>
      )}
    </Modal>
  );
};

export default withTranslate(SendLinkModal);
